__webpack_require__.p = "/samsung/";